<template>
  <div class="web">
  <div class="pc-box">
    <div class="pc-search">
      <div class="pc-search-auto">
        <span>
          <img src="../../../assets/logo.png">
          <em>师生互选</em>
        </span>
      </div>
    </div>
    <div class="myinfo">
      <div class="bg1">
        <van-divider>基本信息</van-divider>
        <div class="line line-col2">
          <span><van-field maxlength="20" v-model="record.fullName" label="账号名称:" placeholder="请输入" input-align="right"/></span>
          <span><van-field name="uploader" label="头像:" input-align="right">
          <template #input>
            <van-uploader :after-read="afterRead" v-model="fileList" :max-count="1"/>
          </template>
        </van-field></span>
        </div>
      </div>
      <!--导师详细信息-->
      <div class="bg1" v-if="record.teacherInfo">
        <van-divider>导师详细信息</van-divider>
        <teacher-edit ref="teacherEdit" :teacherInfo="record.teacherInfo" :facultyTypeOptions="facultyTypeOptions"/>
      </div>

      <!--学生详细信息-->
      <div class="bg1" v-if="record.studentInfo">
        <van-divider>学生详细信息</van-divider>
        <student-edit ref="studentEdit" :studentInfo="record.studentInfo" :facultyTypeOptions="facultyTypeOptions" />
      </div>
      <van-button class="butstyle" type="info" @click="submitUser()">保存</van-button>
    </div>
    <div class="foot">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</div>
  </div>
  </div>
</template>

<script>
  import {customUploadFile} from "@/api/upload";
  import {getUserInfo, updateUser} from "@/api/my/my";
  import {FILE_DISPLAY_PREFIX} from "../../../api/upload";
  import StudentEdit from "./studentEdit-pc";
  import TeacherEdit from "./teacherEdit-pc";
  import {getDictByType} from '@/api/common'

  export default {
    name: "information",
    components: {StudentEdit, TeacherEdit},
    data() {
      return {
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        fileList: [
          {url: '@/assets/头像默认.png'},
        ],
        userHeader: '',
        record: {
          teacherInfo: {},
          studentInfo: {},
        },
        facultyTypeOptions: []
      }
    },
    created() {
      this.getDict()
      //获取用户信息
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.record = res.result
          if (res.result.userHeader) {
            this.fileList[0].url = this.fileDisplayPrefix + res.result.userHeader
          }
        }
      })
    },
    methods: {
      getDict() {
        // 查询字典，院系类型
        getDictByType('faculty_type').then(res => {
          if (res.code === 10000) {
            this.facultyTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      //文件上传
      afterRead(file) {
        customUploadFile(file).then(res => {
          if (res.code == 10000) {
            this.userHeader = res.result[0]
          }
        })

      },
      //提交
      submitUser() {
        // 校验学生必填项
        if (this.record.studentInfo) {
          const studentInfo = this.$refs.studentEdit.getInfo()
          if (!studentInfo.name) {
            this.$toast("姓名不能为空")
            return
          }
          if (!studentInfo.speciality) {
            this.$toast("专业方向不能为空")
            return
          }
          if (!studentInfo.mobileNum) {
            this.$toast("手机号不能为空")
            return
          }
          if (!studentInfo.email) {
            this.$toast("电子邮箱不能为空")
            return
          }
          if (!studentInfo.enrollmentYear) {
            this.$toast("入学年份不能为空")
            return
          }
          if (!studentInfo.resumePath) {
            this.$toast("简历不能为空")
            return
          }
          this.record.studentInfo = studentInfo
        }

        // 校验老师必填项
        if (this.record.teacherInfo) {
          const teacherInfo = this.$refs.teacherEdit.getInfo()
          if (!teacherInfo.name) {
            this.$toast("姓名不能为空")
            return
          }
          if (!teacherInfo.enrollmentDirection) {
            this.$toast("招生方向不能为空")
            return
          }
          if (!teacherInfo.category) {
            this.$toast("导师类别不能为空")
            return
          }
          // if (!teacherInfo.mobileNum) {
          //   this.$toast("手机号不能为空")
          //   return
          // }
          if (!teacherInfo.email) {
            this.$toast("电子邮箱不能为空")
            return
          }
          this.record.teacherInfo = teacherInfo
        }

        if (this.userHeader) {
          this.record.userHeader = this.userHeader
        }
        updateUser(this.record).then(res => {
          if (res.code === 10000) {
            this.$toast("操作成功")
            this.back()
          } else {
            this.$toast("操作失败")
          }
        })
      },
      back() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
.line{
   display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.line-col2 span{
  display: flex;
  flex: 0 49%;
}
/deep/.van-cell{
  align-items: center;
  justify-content: flex-start;
}
  /deep/.van-divider {
    margin: 10px 0;
  }
  .butstyle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    background: #914D3B;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    width: 92%;
    border: none;
  }

  .li-r {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
  }

  .info-box {
    background: #ffffff;
  }

  .myinfo {
    padding: 10px 0px;
    width: 1136px;
    margin: 0 auto;
    background: #ffffff;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .myinfo ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    border-bottom: 1px solid #EEEEEE;
  }

  .myinfo ul li span {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #56555C;
  }

  /deep/ .van-uploader {
    display: flex;
    width: 40px;
    height: 40px;

  }

  /deep/ .van-uploader__preview-image {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    overflow: hidden;
  }

  /deep/ .van-uploader__preview {
    margin: 0;
  }

  .myinfo ul li i {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
  }

  .myinfo ul li i img {
    width: 9px;
    height: 15px;
  }

  /deep/ .van-uploader__upload {
    width: 40px;
    height: 40px;
    border-radius: 100px;
  }

  .myinfo ul li input {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    text-align: right;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #A1A0A6;
  }
  .van-field__label{
    display: flex;
    align-items: center;
  }

    .info-box{
      width: 1024px;
      margin:10px auto 0 auto;
      border-radius: 10px;
      background: none;
    }
    .butstyle{
      width: 191px;
      height: 41px;
      background: #914D3B;
      margin: 0 auto;
      border: none;
    }
    .bg1{
      background: #ffffff;
      margin-bottom: 10px;
      overflow: hidden;
    }
    .van-divider{
      margin: 20px 0;
      font-weight: bold;
      color: #000000;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 22px;
      color: #914D3B;
    }
    .van-divider::after, .van-divider::before{
      display: block;
      -webkit-box-flex: inherit;
      -webkit-flex: inherit;
      flex: inherit;
  }
  .web{
    background: #f9f9f9;
    min-height: 100vh;
  }

  .pc-search{
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    width: 100%;
    height: 76px;
    border-bottom: 1px solid #dedede;
  }
  .pc-search h2{
    display: flex;
    padding: 0 20px;
    font-size:18px;
    font-weight: 600;
  }
  .pc-search-auto{
    width: 1134px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pc-search-auto span{
    display: flex;
    align-items: center;
  }
  .pc-search-auto span img{
    width: 160px;
    height: 39px;
  }
  .pc-search-auto span em{
    display: flex;
    height: 26px;
    align-items: center;
    border-left: 1px solid #dedede;
    margin-left: 10px;
    padding-left: 10px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
  }
  .pc-search-auto h2 a{
    padding: 0 10px 0 0;
    font-size:18px;
    font-weight: 600;
  }
  .pc-box{
    margin: 0 auto;
  }
/deep/.van-cell__value{
  flex: inherit !important;
}
/deep/.van-field__control{
  text-align: left;
}
.foot{
  height: 60px;
  background: #A0060E;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}
</style>
